module.exports = __webpack_public_path__ + "static/media/logo-element.3e5de985.png";